import { useState } from "react";
import { DOK_KATEGORIEN, DOK_GRUPPEN, dokumenteNachCode, pflichtCodes } from "@/lib/dokumentKategorien";
import { DokumentKachel } from "./DokumentKachel";

export const DokumentKacheln = ({ anhaenge, regel, uploadingCode, onUpload, onOpen, onDownload, onDelete, ladefehler }) => {
  const [nurFehlende, setNurFehlende] = useState(false);
  const nachCode = dokumenteNachCode(anhaenge);
  const pflicht = pflichtCodes(regel);
  const praktikum = regel?.praktikum;
  const vorhanden = pflicht.filter((c) => nachCode[c]?.length).length;
  const zeigen = (code) => !nurFehlende || (pflicht.includes(code) && !nachCode[code]?.length);

  return (
    <div className="space-y-5" data-testid="dokument-kacheln">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-stone-900" data-testid="dok-pflicht-zaehler">
            {ladefehler ? "Dokumente nicht geladen" : <>{pflicht.length ? `${vorhanden} von ${pflicht.length} AZAV-Pflichtunterlagen vorhanden · ` : "Keine AZAV-Pflicht für diesen Kurs · "}{(anhaenge || []).length} Dateien gesamt</>}
          </p>
          <p className="text-xs text-stone-500">Datei auf eine Kachel ziehen oder „Hochladen“ klicken – der Begriff wird automatisch richtig gesetzt.</p>
        </div>
        {pflicht.length > 0 && <div className="inline-flex rounded-lg border border-stone-200 p-0.5 bg-stone-50 text-xs">
          {[[false, "Alle"], [true, "Nur fehlende"]].map(([v, l]) => (
            <button key={l} onClick={() => setNurFehlende(v)} data-testid={`dok-filter-${v ? "fehlend" : "alle"}`}
              className={`px-3 py-1 rounded-md transition-colors ${nurFehlende === v ? "bg-white shadow-sm font-medium text-stone-900" : "text-stone-500"}`}>{l}</button>
          ))}
        </div>}
      </div>
      {DOK_GRUPPEN.map((g) => {
        if (g.key === "praktikum" && !praktikum && !["PV", "LZ", "PB"].some((c) => nachCode[c]?.length)) return null;
        const codes = Object.keys(DOK_KATEGORIEN).filter((c) => DOK_KATEGORIEN[c].gruppe === g.key && zeigen(c));
        if (!codes.length) return null;
        return (
          <section key={g.key} data-testid={`dok-gruppe-${g.key}`}>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.12em] text-stone-500 mb-2">{g.label}</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {codes.map((c) => (
                <DokumentKachel key={c} code={c} dateien={nachCode[c] || []} pflicht={pflicht.includes(c)}
                  uploading={uploadingCode === c} onUpload={onUpload} onOpen={onOpen} onDownload={onDownload} onDelete={onDelete} />
              ))}
            </div>
          </section>
        );
      })}
      {nurFehlende && vorhanden === pflicht.length && (
        <p className="text-sm text-emerald-700" data-testid="dok-alles-da">Alle Pflichtunterlagen sind vorhanden.</p>
      )}
    </div>
  );
};
